const $body = document.querySelector('body');

/**
 * Disable scrolling
 */
const disable = () => {
    $body.classList.add('no-scroll');
};

/**
 * Enable scrolling
 */
const enable = () => {
    $body.classList.remove('no-scroll');
};

export default {disable, enable};
